<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col
      md="12"
      class="pa-3 d-flex flex-column"
      v-if="this.conditionEnvironnement()"
  >
  <a class="anchor" id="blocenvironnement"></a>

    <v-card elevation="2">
      <v-card-title>  <v-icon dense left color="green">mdi-family-tree</v-icon>  Structure</v-card-title>
      <v-layout>

        <v-col
            cols="6">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title> {{ nbEtablissements }}</v-list-item-title>

                <v-data-iterator
                    v-if="this.etablissements!=null"
                    :items="etablissements"
                    :items-per-page.sync="itemsPerPage"
                    :page.sync="page"
                    :search="search"
                    ref="etabList"
                    no-data-text="Aucun etablissement supplémentaire">

                  <template v-slot:header>
                    <v-toolbar
                        dark
                        color="blue darken-3"
                        class="mb-1"
                    >
                      <v-text-field
                          v-model="search"
                          clearable
                          flat
                          solo-inverted
                          hide-details
                          prepend-inner-icon="mdi-magnify"
                          label="Search"
                      ></v-text-field>
                      <template v-if="$vuetify.breakpoint.mdAndUp">
                        <v-spacer></v-spacer>
                        {{ nbEtablissements }}
                      </template>
                    </v-toolbar>
                  </template>

                  <template v-slot:default="props">
                    <v-row>
                      <v-col
                          v-for="item in props.items"
                          :key="item.siret"
                          cols="6"
                          sm="12"
                          md="12"
                          lg="12"
                      >
                        <SiretItem v-bind:siret="item" :key="item.siret" @click.native="displaySelected(item.siret)"/>

                      </v-col>
                    </v-row>
                  </template>

                </v-data-iterator>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col class="display-3"
               cols="6">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title> {{ actionnaires }}</v-list-item-title>
                <v-data-table
                    v-if="this.actionnaireslist != null && this.actionnaireslist.length>0"
                    dense
                    :headers="headers"
                    :items="actionnaireslist"
                    item-key="nom"
                    class="elevation-1"
                >
                  <template #item.siren="{ item }"><a @click="displaySelected(item.siren)">
                    <v-icon x-small v-if="item.siren!=''">mdi-open-in-new</v-icon>
                    {{ item.siren ? item.siren : "" }}</a></template>
                </v-data-table>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title> {{ filiales }}</v-list-item-title>

                <v-data-table
                    v-if="this.filialesList != null  && this.filialesList.length>0"
                    dense
                    :headers="headers"
                    :items="filialesList"
                    item-key="nom"
                    class="elevation-1"
                >
                  <template #item.siren="{ item }"><a @click="displaySelected(item.siren)">
                    <v-icon x-small v-if="item.siren!=''">mdi-open-in-new</v-icon>
                    {{ item.siren ? item.siren : "" }}</a></template>

                </v-data-table>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-layout>
    </v-card>
  </v-col>
</template>

<script>
import SiretItem from "../freeSearch/SiretItem";

export default {
  name: "Structure",
  props: [""],
  components: {
    SiretItem,
  },
  data: () => ({
    itemsPerPageArray: [10, 50, 100, 1000],
    search: '',
    filter: {},
    sortDesc: false,
    page: 1,
    itemsPerPage: 4,


  }),
  computed: {
    nbFiltered() {
      return this.filter.length
    },
    numberOfPages() {
      return Math.ceil(this.etablissements.length / this.itemsPerPage)
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'Name')
    },

    etablissements: function () {
      var etabs = this.$store.getters.getbloc("environnement", "donnees", "listeEtablissements", null, "valeur")
      return (etabs != null && etabs.length > 0 ? etabs : null)
    },
    nbEtablissements: function () {
      return this.$store.getters.getbloc("environnement", "donnees", "listeEtablissements", "Aucun autre etablissement", "libelle")
    },
    actionnaireslist: function () {
      return this.$store.getters.getbloc(
          "environnement",
          "donnees",
          "actionnaires",
          null,
          "valeur"
      )
    },
    actionnaires: function () {

      return this.$store.getters.getbloc(
          "environnement",
          "donnees",
          "actionnaires",
          "",
          "libelle"
      );
    },
    filiales: function () {
      return this.$store.getters.getbloc(
          "environnement",
          "donnees",
          "filiales",
          "",
          "libelle"
      );
    },
    filialesList: function () {
      const filiales = this.$store.getters.getbloc("environnement", "donnees", "filiales")
      if (filiales === null){
          return []
      } else {
           return filiales.valeur
      }
    },
    headers() {
      return [
        {
          text: "Nom",
          align: "start",
          sortable: false,
          value: "nom",
          fixed: true,
          width: "10px",
        },
        {
          text: "Siren",
          value: "siren",
          align: "start",
          fixed: true,
          width: "100px",
          formatter: this.formatCurrency,
        },
      ];
    },
  },
  methods: {
    conditionEnvironnement() {
      return this.$store.getters.condition("environnement", "donnees");
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number
    },
    displaySelected(siret) {
      this.$store.dispatch('getEtablissement', siret)
    },
  },
};
</script>
